import { styled } from '@mui/system';
import { Typography, Skeleton } from '@mui/material';
import Switch from '@mui/material/Switch';

const RootDiv = styled('div')({
  display: 'flex',
  margin: '0 0 0 0',
  backgroundColor: '#FFFFFF',
  padding: '12px 15px',
  justifyContent: 'space-between',
  border: '1px solid #EAEAEA',
  borderRadius: '10px',
  alignItems: 'center',
});

const Text = styled(Typography)({
  fontSize: '12px',
  fontWeight: '500',
  fontFamily: 'Poppins',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color: '#414046',
});

const SwitchButton = styled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#0A7ABE',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#AFD5FF',
  },
});

const SkeletonText = styled(Skeleton)({
  width: '107px',
  height: '20px',
});

const SkeletonSwitch = styled(Skeleton)({
  width: '58px',
  height: '38px',
});

export { RootDiv, Text, SwitchButton, SkeletonText, SkeletonSwitch };
